import type { ReactNode } from "react";
import { StyleSheet, View } from "react-native";

import { spacing } from "~/styles/theme";
import { PageTitle } from "./PageTitle";
import { ScrollScreen } from "./ScrollScreen";
import { Stack } from "./Stack";

export function ProtectedScreen({
  title,
  subtitle,
  children,
  narrow = false,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  /** Form-style pages: cap the column so inputs don't stretch across a wide desktop. */
  narrow?: boolean;
}) {
  return (
    <ScrollScreen>
      <View style={[stylesheet.column, narrow ? stylesheet.narrow : null]}>
        <Stack gap="lg">
          <View style={stylesheet.header}>
            <PageTitle title={title} subtitle={subtitle} />
          </View>
          <Stack gap="lg">{children}</Stack>
        </Stack>
      </View>
    </ScrollScreen>
  );
}

const stylesheet = StyleSheet.create({
  column: { width: "100%" },
  narrow: { maxWidth: 720 },
  header: { gap: spacing.xs, marginBottom: spacing.xs },
});
